import { ControlProps, isControl, rankWith } from "@jsonforms/core";
import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import { formatCurrency } from "../Grid/ValueFormatters";

const CurrencyRenderer = (props: ControlProps) => {
  const { core } = useJsonForms();

  // Same source the grid formatter uses, so a value cannot be formatted one way
  // in the grid and another in the detail panel.
  const currencyCode = core?.data?.cdCurrency;

  const isEmpty = props.data === null || props.data === undefined || props.data === "";

  return (
    <div className="control">
      <label>{props.label}</label>
      <div>
        <span>{isEmpty ? "" : formatCurrency(props.data, currencyCode)}</span>
      </div>
    </div>
  );
};

export const currencyRendererTester = rankWith(100, (uischema) => {
  if (!isControl(uischema)) return false;
  return uischema.options?.variant === "currency";
});

export default withJsonFormsControlProps(CurrencyRenderer);
